import Phaser from 'phaser';

export class BootScene extends Phaser.Scene {
  constructor() {
    super('BootScene');
  }

  preload() {
    // Minimal assets for loading screen
    this.load.setPath('assets/');
  }

  create() {
    this.scene.start('PreloadScene');
  }
}

